import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export default function NoteTooltip(props) {
    const tooltip = (
        <Tooltip placement="right" className="in" id="tooltip" style={{ marginTop: '5px' }}>
            {props.note}
        </Tooltip>
    );
    return (
        <OverlayTrigger
            overlay={tooltip}
            placement="right"
            delayShow={300}
            delayHide={150}
        >
            {props.children}
        </OverlayTrigger>
    );
}



/** WEBPACK FOOTER **
 ** ./src/components/product/note-tooltip.jsx
 **/